export const DEFAULT_FONT_SIZE = 12;
